export default function capitalize(stringg?: string): string {
  if (!stringg) {
    return '';
  }
  return stringg ? stringg.charAt(0).toUpperCase() + stringg.slice(1) : '';
}
